<template>
    <div class="user-message">
        <div class="title">
            Texte analysé
        </div>
        <div class="content">
            {{ message.content }}
        </div>    
    </div>
</template>

<script>    
export default{
    props:{
        message:Object
    }
}
</script>

<style scoped>    
.user-message{
    margin-bottom:24px;
    border-left:4px solid #991b1b;
    padding-left:18px;
}

.title{
    color:#b3b3b3;
    font-size:13px;
    font-weight:600;
    text-transform:uppercase;
    letter-spacing:.08em;
    margin-bottom:10px;    
}

.content{
    color:white;
    line-height:1.6;
}
</style>